var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinanceSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9395 19.5L16.3979 15.9521L19.9395 19.5ZM18.3605 11.2105C18.3605 12.9903 17.6535 14.6971 16.395 15.9556C15.1366 17.2141 13.4297 17.9211 11.65 17.9211C9.87024 17.9211 8.16339 17.2141 6.90492 15.9556C5.64645 14.6971 4.93945 12.9903 4.93945 11.2105C4.93945 9.43078 5.64645 7.72394 6.90492 6.46547C8.16339 5.207 9.87024 4.5 11.65 4.5C13.4297 4.5 15.1366 5.207 16.395 6.46547C17.6535 7.72394 18.3605 9.43078 18.3605 11.2105V11.2105Z",
    stroke: "#B6B6B6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceSearchIcon);
export default __webpack_public_path__ + "static/media/finance-search-icon.6267e12e3cdff12623fac937354a2a73.svg";
export { ForwardRef as ReactComponent };